import React, { useEffect, useState, useRef } from "react";
import { Spin, Modal, Menu, Dropdown, message } from "antd";
import { PlusOutlined, DeleteOutlined, LoadingOutlined } from "@ant-design/icons";
import axios from "axios";

const API_ROOT = `${process.env.REACT_APP_BACKEND_URL}`;
function RecipePhotosGrid({ recipeId, readonly, photos, setPhotos, loading }) {

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewIndex, setPreviewIndex] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [pendingDelete, setPendingDelete] = useState(null);
  const fileInputRef = useRef();

  //console.log("photos value and type:", photos, typeof photos, Array.isArray(photos));

  const realPhotos = photos.filter((p) => !p.uploading);

  const handleUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setUploading(true);
    setPhotos((curr) => [
  ...(Array.isArray(curr) ? curr : []),
  { id: "uploading", uploading: true },
]);
console.log(photos);

    const formData = new FormData();
    formData.append("recipeId", recipeId);
    formData.append("file", file);
    try {
      await axios.post(`${API_ROOT}/recipe/photos/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      });
      message.success("Photo uploaded");
      const res = await axios.get(`${API_ROOT}/recipe/photos?recipeId=${recipeId}`,{ withCredentials: true });
      //   console.log(res.data);
      setPhotos(Array.isArray(res.data) ? res.data : []);
      // console.log(photos);

    } catch {
      message.error("Upload failed");
      setPhotos((curr) => curr.filter((p) => p.id !== "__uploading__"));
    } finally {
      setUploading(false);
    }
  };

  const handleDelete = async (photoId) => {
    try {
      await axios.delete(`${API_ROOT}/recipe/photos/${photoId}`, { withCredentials: true });
      setPhotos((curr) =>
  (Array.isArray(curr) ? curr : []).filter(
    (p) => p.id !== photoId && p.id !== "uploading"
  )
);

      message.success("Deleted photo");
    } catch {
      message.error("Failed to delete photo");
    } finally {
      setPendingDelete(null);
    }
  };

  const handleImageClick = (photoId) => {
    const idx = realPhotos.findIndex((p) => p.id === photoId);
    if (idx !== -1) {
      setPreviewIndex(idx);
      setPreviewOpen(true);
    }
  };

  const closePreview = () => setPreviewOpen(false);
  const nextPreview = () => setPreviewIndex((idx) => (idx + 1) % realPhotos.length);
  const prevPreview = () => setPreviewIndex((idx) => (idx - 1 + realPhotos.length) % realPhotos.length);

  // Use controlled modal and component state, not Modal.confirm static
  const contextMenu = (photoId) => (
    <Menu
      items={[
        {
          key: "delete",
          icon: <DeleteOutlined />,
          label: "Delete",
          onClick: () => setPendingDelete(photoId),
        },
      ]}
    />
  );

  const columns = 4;
  const triggerFileInput = () => fileInputRef.current && fileInputRef.current.click();

  return (
    <Spin spinning={loading}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gap: 16,
          maxWidth: 500,
        }}
      >
        {photos.map((photo) =>
          photo.uploading ? (
            <div
              key="uploading"
              style={{
                aspectRatio: "1",
                width: "100%",
                background: "#e0e0e0",
                borderRadius: 6,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 32,
              }}
            >
              <LoadingOutlined spin />
            </div>
          ) : (
            <Dropdown
              overlay={contextMenu(photo.id)}
              trigger={["contextMenu"]}
              key={photo.id}
            >
              <div
                style={{
                  aspectRatio: "1",
                  width: "100%",
                  background: "#cce7fa",
                  borderRadius: 6,
                  overflow: "hidden",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => handleImageClick(photo.id)}
              >
                <img
                  src={`${API_ROOT}/recipe/photos/display/${photo.id}?width=400&height=400`}
                  alt="Recipe"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  draggable={false}
                />
              </div>
            </Dropdown>
          )
        )}
        {!uploading && (
          <div
            onClick={triggerFileInput}
            style={{
              aspectRatio: "1",
              width: "100%",
              border: "2px dashed #aaa",
              borderRadius: 6,
              color: "#333",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <PlusOutlined style={{ fontSize: 36 }} />
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleUpload}
              style={{ display: "none" }}
              accept="image/*"
            />
          </div>
        )}
      </div>
      {/* Fullscreen Modal Preview */}
      <Modal
        open={previewOpen}
        onCancel={closePreview}
        footer={null}
        width="90vw"
        style={{ top: 20 }}
  styles={{
    body: {
      background: "#ffffff",
      padding: 0,
      textAlign: "center"
    }
  }}
      >
        {realPhotos.length > 0 && previewIndex >= 0 && (
          <div style={{ position: "relative" }}>
            <img
              src={`${API_ROOT}/recipe/photos/display/${realPhotos[previewIndex].id}?width=800&height=800`}
              alt=""
style={{
    maxWidth: "80vw",
    maxHeight: "80vh",
    width: "auto",
    height: "auto",
    objectFit: "contain",
    background: "#ffffff",
    display: "block",
    margin: "0 auto"
  }}
              draggable={false}
            />
            <div style={{
              position: "absolute",
              top: "50%",
              left: 10,
              transform: "translateY(-50%)",
              fontSize: 28,
              color: "#807f7fff",
              cursor: "pointer",
              userSelect: "none",
            }} onClick={prevPreview}>←</div>
            <div style={{
              position: "absolute",
              top: "50%",
              right: 10,
              transform: "translateY(-50%)",
              fontSize: 28,
              color: "#807f7fff",
              cursor: "pointer",
              userSelect: "none",
            }} onClick={nextPreview}>→</div>
          </div>
        )}
      </Modal>
      {/* Delete confirmation modal */}
      <Modal
        open={!!pendingDelete}
        onCancel={() => setPendingDelete(null)}
        onOk={() => handleDelete(pendingDelete)}
        okType="danger"
        okText="Delete"
        cancelText="Cancel"
        title="Delete this photo?"
      >
        Are you sure you want to delete this photo?
      </Modal>
    </Spin>
  );
}

export default RecipePhotosGrid;
